import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import CTAButton from '../../components/CTAButton';
import { geti18n } from '../../utils';
import { createLocateARetailerURL, createRequestAQuoteURL } from '../../redux/selectors/paymentOptions';
import { hasUserSelectedTrim } from '../../redux/selectors/trim';
import { getVendorParam, getDestinationURLParam, getReferrerURLParam } from '../../redux/selectors/helios';
import {
  StyledThankYouTitle,
  StyledThankYouContent,
  StyledFormCTAWrapper,
  StyledThankYouModal
} from './styles';

class FormThankYou extends Component {

  static propTypes = {
    title: PropTypes.string,
    content: PropTypes.string,
    locateARetailerURL: PropTypes.string,
    requestAQuoteText: PropTypes.string,
    requestAQuoteURL: PropTypes.string,
    vendor: PropTypes.string.isRequired,
    destinationURL: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool
    ]).isRequired,
    referrerURL: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool
    ]).isRequired,
    locateARetailerText: PropTypes.string,
    trimWasSelected: PropTypes.bool.isRequired,
    locateARetailerMKS: PropTypes.string,
    requestAQuoteMKS: PropTypes.string
  }

  static defaultProps = {
    title: '',
    content: '',
    locateARetailerText: geti18n('offerPanel.summaryPanel.retailerButton'),
    requestAQuoteText: geti18n('offerPanel.summaryPanel.quoteButton'),
    locateARetailerMKS: geti18n('offerPanel.summaryPanel.retailerButtonMKS'),
    requestAQuoteMKS: geti18n('offerPanel.summaryPanel.quoteButtonMKS'),
    locateARetailerURL: '',
    requestAQuoteURL: '',
    monthlyPayment: 0,
  }

  // Renders the 2 CTA buttons on the bottom of the card
  renderCTAS = () => {
    const {
      locateARetailerText,
      locateARetailerURL,
      requestAQuoteText,
      requestAQuoteURL,
      vendor,
      destinationURL,
      referrerURL,
      trimWasSelected,
      locateARetailerMKS,
      requestAQuoteMKS
    } = this.props;

    //                  ***** HELIOS INTEGRATION *****
    // Logic to use the destination and referrer URls as sent in from Helios
    // Takes in the destination URL from the query string and places it into the CTA's
    const retailerURL = (vendor === 'helios' && referrerURL && !trimWasSelected) ? referrerURL : locateARetailerURL;
    const quoteURL = (vendor === 'helios' && destinationURL && !trimWasSelected) ? destinationURL : requestAQuoteURL;

    return (
      <div>
        <StyledFormCTAWrapper>
          <CTAButton title={locateARetailerText} url={retailerURL} linkName={`SUBSCRIBE_${locateARetailerMKS}`} className="secondary" />
        </StyledFormCTAWrapper>
        <StyledFormCTAWrapper>
          <CTAButton title={requestAQuoteText} url={quoteURL} linkName={`SUBSCRIBE_${requestAQuoteMKS}`} />
        </StyledFormCTAWrapper>
      </div>
    )
  };

  render() {
    const { title, content } = this.props;

    return (
      <StyledThankYouModal>
        <StyledThankYouTitle>{title}</StyledThankYouTitle>
        <StyledThankYouContent>{content}</StyledThankYouContent>
        <div>
          {this.renderCTAS()}
        </div>
      </StyledThankYouModal>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({ //eslint-disable-line
  locateARetailerURL: createLocateARetailerURL(state),
  requestAQuoteURL: createRequestAQuoteURL(state),
  vendor: getVendorParam(state),
  destinationURL: getDestinationURLParam(state),
  referrerURL: getReferrerURLParam(state),
  trimWasSelected: hasUserSelectedTrim(state)
});

export default connect(mapStateToProps)(FormThankYou);



/** WEBPACK FOOTER **
 ** ./src/components/FormThankYou/index.js
 **/